import React from "react";

import { ComponentRenderer } from "../../ComponentRenderer";
import { notEmpty } from "../../../utils/notEmpty";
import { NavbarWithMenuItems } from "./NavbarWithMenuItems";
import {
  ComponentNavigationNavbar,
  Enum_Componentnavigationnavbar_Variant,
} from "../../../graphql/generated/graphql";

export function Navbar({
  menu,
  navbarVariant = Enum_Componentnavigationnavbar_Variant.Default,
}: ComponentNavigationNavbar & {
  navbarVariant?: Enum_Componentnavigationnavbar_Variant;
}): JSX.Element {
  //@ts-ignore
  if (menu?.data?.attributes?.components?.length > 0) {
    return (
      <div className="component-navbar flex flex-wrap gap-12">
        <ComponentRenderer
          components={
            //@ts-ignore
            menu?.data?.attributes?.components.filter(notEmpty) || []
          }
        />
      </div>
    );
  }

  return (
    <NavbarWithMenuItems id="1" menu={menu} navbarVariant={navbarVariant} />
  );
}
